export default "__VITE_ASSET__lx2udED1__"